import { render, staticRenderFns } from "./phoneModal.vue?vue&type=template&id=3bcc5dc8&"
import script from "./phoneModal.vue?vue&type=script&lang=js&"
export * from "./phoneModal.vue?vue&type=script&lang=js&"
import style0 from "./phoneModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports